import cn from 'classnames';

import s from './loader.module.css';

const Loader = ({ length = 5 }) =>
  Array.from(Array(length).keys()).map(item => (
    <tr key={item}>
      <td
        className={cn(
          'dataset align-middle border-b border-tundora',
          item === length - 1 && 'border-b-0'
        )}
      >
        <div className="flex items-center">
          <div
            className={cn(
              s.loader,
              'w-[68px] h-[68px] relative overflow-hidden rounded-full bg-neutral-800'
            )}
          />
          <span className="ml-4 flex-1 space-y-[10px]">
            <div
              className={cn(
                s.loader,
                'text-xs leading-5 w-5/6 h-[10px] bg-neutral-800 rounded-3xl'
              )}
            />
            <div
              className={cn(
                s.loader,
                'text-xs leading-5 w-3/5 h-[10px] bg-neutral-800 rounded-3xl'
              )}
            />
            <div
              className={cn(
                s.loader,
                'text-xs leading-5 w-2/4 h-[10px] bg-neutral-800 rounded-3xl'
              )}
            />
          </span>
        </div>
      </td>
      <td
        className={cn(
          'data-provided align-middle border-b border-tundora',
          item === length - 1 && 'border-b-0'
        )}
      >
        <div className="flex items-center">
          <span className="flex-1 space-y-[10px]">
            <div
              className={cn(
                s.loader,
                'text-xs leading-5 w-5/6 h-[10px] bg-neutral-800 rounded-3xl'
              )}
            />
            <div className="text-xs leading-5 w-3/5 h-[10px] bg-neutral-800 rounded-3xl invisible" />
            <div className="text-xs leading-5 w-2/4 h-[10px] bg-neutral-800 rounded-3xl invisible" />
          </span>
        </div>
      </td>
      <td
        className={cn(
          'annotation align-middle border-b border-tundora',
          item === length - 1 && 'border-b-0'
        )}
      >
        <div className="flex items-center">
          <span className="flex-1 space-y-[10px]">
            <div
              className={cn(
                s.loader,
                'text-xs leading-5 w-5/6 h-[10px] bg-neutral-800 rounded-3xl'
              )}
            />
            <div className="text-xs leading-5 w-3/5 h-[10px] bg-neutral-800 rounded-3xl invisible" />
            <div className="text-xs leading-5 w-2/4 h-[10px] bg-neutral-800 rounded-3xl invisible" />
          </span>
        </div>
      </td>
      <td
        className={cn('align-middle border-b border-tundora', item === length - 1 && 'border-b-0')}
      >
        <div className="flex items-center">
          <span className="flex-1 space-y-[10px]">
            <div
              className={cn(
                s.loader,
                'text-xs leading-5 w-5/6 h-[10px] bg-neutral-800 rounded-3xl'
              )}
            />
            <div className="text-xs leading-5 w-3/5 h-[10px] bg-neutral-800 rounded-3xl invisible" />
            <div className="text-xs leading-5 w-2/4 h-[10px] bg-neutral-800 rounded-3xl invisible" />
          </span>
        </div>
      </td>
      <td
        className={cn('align-middle border-b border-tundora', item === length - 1 && 'border-b-0')}
      >
        <div className="flex items-center">
          <span className="flex-1 space-y-[10px]">
            <div
              className={cn(
                s.loader,
                'text-xs leading-5 w-5/6 h-[10px] bg-neutral-800 rounded-3xl'
              )}
            />
            <div className="text-xs leading-5 w-3/5 h-[10px] bg-neutral-800 rounded-3xl invisible" />
            <div className="text-xs leading-5 w-2/4 h-[10px] bg-neutral-800 rounded-3xl invisible" />
          </span>
        </div>
      </td>
    </tr>
  ));

export const MobileLoader = ({ length = 5 }) => (
  <div className="border border-tundora rounded-md lg:hidden">
    {Array.from(Array(length).keys()).map(item => (
      <div
        key={item}
        className={cn(item === length - 1 && 'border-b-0', 'p-4 border-b border-tundora')}
      >
        <div className="flex items-center">
          <div
            className={cn(
              s.loader,
              'w-[68px] h-[68px] relative overflow-hidden rounded-full bg-neutral-800'
            )}
          />
          <span className="ml-4 flex-1 space-y-[10px]">
            <div
              className={cn(
                s.loader,
                'text-xs leading-5 w-5/6 h-[10px] bg-neutral-800 rounded-3xl'
              )}
            />
            <div
              className={cn(
                s.loader,
                'text-xs leading-5 w-3/5 h-[10px] bg-neutral-800 rounded-3xl'
              )}
            />
            <div
              className={cn(
                s.loader,
                'text-xs leading-5 w-2/4 h-[10px] bg-neutral-800 rounded-3xl'
              )}
            />
          </span>
        </div>
      </div>
    ))}
  </div>
);

export default Loader;
